import { render, staticRenderFns } from "./SignInEmailConfirm.vue?vue&type=template&id=4d3271a8&scoped=true"
import script from "./SignInEmailConfirm.vue?vue&type=script&lang=ts"
export * from "./SignInEmailConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SignInEmailConfirm.vue?vue&type=style&index=0&id=4d3271a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3271a8",
  null
  
)

export default component.exports